import { type AppDispatch } from "../../store/reducers";
import { setLoadingStores } from "./reducers";

// The data parameter carries template props through useSSRStorePrefill's
// dependency array but isn't dispatched into Redux — the template props
// are consumed directly by the component via props, not via the store.
// Used by RetailLocatorPageSSR and FlagshipNearestStoresSSR.
export const prefillSSRRetailData = (
    dispatch: AppDispatch,
    _data: object,
): void => {
    dispatch(setLoadingStores(true));
};
